export default {
    zh: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 视频生成器 - AI舞蹈视频创作',
        pageDescription: '体验ByteDance的Seedance视频生成器，专注于舞蹈视频创作、动作生成和多样化风格功能。在WeryAI平台免费创建专业AI舞蹈视频。',
        pageKeywords: 'Seedance, AI视频生成器, 舞蹈视频创作, 动作生成, 音乐同步, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro 视频生成器',
        generatorDescription: 'Seedance 是 ',
        generatorDescriptionHighlight1: 'ByteDance 推出的新 AI 视频生成模型',
        generatorDescriptionText2: '，由 Pixeldance 和 Seedweed 开发团队合并而成。Seedance 1.0 最近在',
        generatorDescriptionHighlight2: '视频竞技场排行榜上稳居榜首',
        generatorDescriptionText3: '。该工具具有',
        generatorDescriptionHighlight3: '多镜头能力、流畅且导向性强的摄像机移动',
        generatorDescriptionText4: '等功能！使用 ',
        generatorDescriptionHighlight4: 'WeryAI 中的 Seedance 创建 AI 视频',
        generatorDescriptionEnd: '。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro 的主要功能',

        // 精准的语义理解
        accurateSemanticTitle: '精准的语义理解',
        accurateSemanticDescription: '精准解读复杂的用户提示',

        // 动态摄像机控制
        dynamicCameraControlTitle: '动态摄像机控制',
        dynamicCameraControlDescription: '包括缩放、平移和跟踪',

        // 多镜头生成保持一致
        multiShotGenerationTitle: '多镜头生成保持一致',
        multiShotGenerationDescription: '生成多个镜头，并保持一致性',

        // 支持多种风格
        multipleStylesTitle: '支持多种风格',
        multipleStylesDescription: '支持多种艺术风格和主题',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Seedance模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Seedance"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的舞蹈创意',
        step2Description: '描述您想要生成的舞蹈风格和动作，或上传参考图片，并选择您喜欢的音乐和节奏。',
        step3Title: '下载您的舞蹈视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的精彩舞蹈视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 视频生成器',
        runwayTitle: 'Runway AI 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance，将您的舞蹈创意转化为精彩视频',
        ctaButton: '在 WeryAI 上试用 Seedance',

        ctaDisclaimer: '无需信用卡',

    },
    en: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dance Video Creation',
        pageDescription: 'Experience Seedance video generator by ByteDance with dance video creation, motion generation, and diverse style features. Create professional AI dance videos for free on WeryAI platform.',
        pageKeywords: 'Seedance, AI video generator, dance video creation, motion generation, music synchronization, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'a new AI video generation model launched by ByteDance',
        generatorDescriptionText2: ', formed by the merger of Pixeldance and Seedweed development teams. Seedance 1.0 recently ',
        generatorDescriptionHighlight2: 'ranks first on the Video Arena leaderboard',
        generatorDescriptionText3: '. The tool features ',
        generatorDescriptionHighlight3: 'multi-shot capabilities, smooth and directed camera movement',
        generatorDescriptionText4: ' and more! Use ',
        generatorDescriptionHighlight4: 'Seedance on WeryAI to create AI videos',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Accurate Semantic Understanding',
        accurateSemanticDescription: 'Precisely interprets complex user prompts',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamic Camera Control',
        dynamicCameraControlDescription: 'Including zoom, pan, and tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-Shot Generation with Consistency',
        multiShotGenerationDescription: 'Generates multiple shots while maintaining consistency',

        // Support for multiple styles
        multipleStylesTitle: 'Support for Multiple Styles',
        multipleStylesDescription: 'Supports various artistic styles and themes',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Seedance Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Seedance" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Dance Creative Ideas',
        step2Description: 'Describe the dance style and movements you want to generate, or upload reference images, and choose your preferred music and rhythm.',
        step3Title: 'Download Your Dance Video',
        step3Description: 'Click "Create" to download or share the generated spectacular dance video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance now and transform your dance ideas into amazing videos',
        ctaButton: 'Try Seedance on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 動画ジェネレーター - AIダンス動画作成',
        pageDescription: 'ByteDanceのSeedance動画ジェネレーターを体験。ダンス動画作成、モーション生成、多様なスタイル機能。WeryAIプラットフォームで無料でプロフェッショナルなAIダンス動画を作成。',
        pageKeywords: 'Seedance, AI動画ジェネレーター, ダンス動画作成, モーション生成, 音楽同期, 無料AI動画, WeryAI, 動画制作',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro 動画ジェネレーター',
        generatorDescription: 'Seedanceは',
        generatorDescriptionHighlight1: 'ByteDanceが発表した新しいAI動画生成モデル',
        generatorDescriptionText2: 'で、PixeldanceとSeedweed開発チームが統合されて形成されました。Seedance 1.0は最近',
        generatorDescriptionHighlight2: '動画アリーナランキングで首位を維持',
        generatorDescriptionText3: 'しています。このツールは',
        generatorDescriptionHighlight3: 'マルチショット機能、スムーズで方向性のあるカメラ移動',
        generatorDescriptionText4: 'などの機能を備えています！',
        generatorDescriptionHighlight4: 'WeryAIのSeedanceでAI動画を作成',
        generatorDescriptionEnd: 'しましょう。',
        
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',
        coreFeaturesTitle: 'Seedance 1.0 Proの主な機能',
        accurateSemanticTitle: '正確なセマンティック理解',
        accurateSemanticDescription: '複雑なユーザープロンプトを正確に解釈',
        dynamicCameraControlTitle: 'ダイナミックカメラコントロール',
        dynamicCameraControlDescription: 'ズーム、パン、トラッキングを含む',
        multiShotGenerationTitle: '一貫性のあるマルチショット生成',
        multiShotGenerationDescription: '複数のショットを生成し、一貫性を維持',
        multipleStylesTitle: '複数のスタイルをサポート',
        multipleStylesDescription: '様々な芸術スタイルとテーマをサポート',
        howToUseTitle: '使い方',
        step1Title: 'Seedanceモデルを選択',
        step1Description: '「AI動画生成」ページに移動し、モデルドロップダウンメニューで「Seedance」をクリックします。',
        step2Title: 'ダンスのアイデアを入力',
        step2Description: '生成したいダンススタイルと動きを説明するか、参照画像をアップロードし、お好みの音楽とリズムを選択します。',
        step3Title: 'ダンス動画をダウンロード',
        step3Description: '「作成」をクリックして、生成された素晴らしいダンス動画をダウンロードまたは共有します。',
        youtubeTitle: 'SeedanceモデルについてのYouTube動画',
        xPostsTitle: 'Seedanceモデルについての人気X投稿',
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: 'よくある質問',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐSeedanceを体験し、あなたのダンスアイデアを素晴らしい動画に変換',
        ctaButton: 'WeryAIでSeedanceを試す',
        ctaDisclaimer: 'クレジットカード不要',
            step1DescriptionHighlight: '', // Pending alignment
    },
    ko: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 비디오 생성기 - AI 댄스 비디오 제작',
        pageDescription: 'ByteDance의 Seedance 비디오 생성기를 체험하세요. 댄스 비디오 제작, 모션 생성, 다양한 스타일 기능. WeryAI 플랫폼에서 무료로 전문적인 AI 댄스 비디오를 제작하세요.',
        pageKeywords: 'Seedance, AI 비디오 생성기, 댄스 비디오 제작, 모션 생성, 음악 동기화, 무료 AI 비디오, WeryAI, 비디오 제작',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro 비디오 생성기',
        generatorDescription: 'Seedance는 ',
        generatorDescriptionHighlight1: 'ByteDance가 출시한 새로운 AI 비디오 생성 모델',
        generatorDescriptionText2: '로, Pixeldance와 Seedweed 개발팀이 합병하여 형성되었습니다. Seedance 1.0은 최근 ',
        generatorDescriptionHighlight2: '비디오 아레나 순위에서 1위를 유지',
        generatorDescriptionText3: '하고 있습니다. 이 도구는 ',
        generatorDescriptionHighlight3: '멀티샷 기능, 부드럽고 방향성 있는 카메라 이동',
        generatorDescriptionText4: ' 등의 기능을 갖추고 있습니다! ',
        generatorDescriptionHighlight4: 'WeryAI의 Seedance로 AI 비디오 생성',
        generatorDescriptionEnd: '하세요.',
        
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',
        coreFeaturesTitle: 'Seedance 1.0 Pro의 주요 기능',
        accurateSemanticTitle: '정확한 의미 이해',
        accurateSemanticDescription: '복잡한 사용자 프롬프트를 정확하게 해석',
        dynamicCameraControlTitle: '동적 카메라 제어',
        dynamicCameraControlDescription: '줌, 팬, 트래킹 포함',
        multiShotGenerationTitle: '일관성 있는 멀티샷 생성',
        multiShotGenerationDescription: '여러 샷을 생성하면서 일관성 유지',
        multipleStylesTitle: '다양한 스타일 지원',
        multipleStylesDescription: '다양한 예술 스타일과 테마 지원',
        howToUseTitle: '사용 방법',
        step1Title: 'Seedance 모델 선택',
        step1Description: '"AI 비디오 생성" 페이지로 이동한 후 모델 드롭다운 메뉴에서 "Seedance"를 클릭합니다.',
        step2Title: '댄스 아이디어 입력',
        step2Description: '생성하려는 댄스 스타일과 동작을 설명하거나 참조 이미지를 업로드하고 원하는 음악과 리듬을 선택합니다.',
        step3Title: '댄스 비디오 다운로드',
        step3Description: '"만들기"를 클릭하여 생성된 멋진 댄스 비디오를 다운로드하거나 공유합니다.',
        youtubeTitle: 'Seedance 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Seedance 모델에 대한 인기 X 게시물',
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',
        faqTitle: '자주 묻는 질문',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Seedance를 체험하고 당신의 댄스 아이디어를 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Seedance 사용해보기',
        ctaDisclaimer: '신용카드 불필요',
            step1DescriptionHighlight: '', // Pending alignment
    },
    tw: {

        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro 视频生成器 - AI舞蹈视频创作',
        pageDescription: '体验ByteDance的Seedance视频生成器，专注于舞蹈视频创作、动作生成和多样化风格功能。在WeryAI平台免费创建专业AI舞蹈视频。',
        pageKeywords: 'Seedance, AI视频生成器, 舞蹈视频创作, 动作生成, 音乐同步, 免费AI视频, WeryAI, 视频制作',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro 视频生成器',
        generatorDescription: 'Seedance 是 ',
        generatorDescriptionHighlight1: 'ByteDance 推出的新 AI 视频生成模型',
        generatorDescriptionText2: '，由 Pixeldance 和 Seedweed 开发团队合并而成。Seedance 1.0 最近在',
        generatorDescriptionHighlight2: '视频竞技场排行榜上稳居榜首',
        generatorDescriptionText3: '。该工具具有',
        generatorDescriptionHighlight3: '多镜头能力、流畅且导向性强的摄像机移动',
        generatorDescriptionText4: '等功能！使用 ',
        generatorDescriptionHighlight4: 'WeryAI 中的 Seedance 创建 AI 视频',
        generatorDescriptionEnd: '。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro 的主要功能',

        // 精准的语义理解
        accurateSemanticTitle: '精准的语义理解',
        accurateSemanticDescription: '精准解读复杂的用户提示',

        // 动态摄像机控制
        dynamicCameraControlTitle: '动态摄像机控制',
        dynamicCameraControlDescription: '包括缩放、平移和跟踪',

        // 多镜头生成保持一致
        multiShotGenerationTitle: '多镜头生成保持一致',
        multiShotGenerationDescription: '生成多个镜头，并保持一致性',

        // 支持多种风格
        multipleStylesTitle: '支持多种风格',
        multipleStylesDescription: '支持多种艺术风格和主题',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Seedance模型',
        step1Description: '前往"AI视频生成"页面，然后在模型下拉菜单中点击"Seedance"。',
        step1DescriptionHighlight: 'AI视频生成',
        step2Title: '输入您的舞蹈创意',
        step2Description: '描述您想要生成的舞蹈风格和动作，或上传参考图片，并选择您喜欢的音乐和节奏。',
        step3Title: '下载您的舞蹈视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的精彩舞蹈视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI 影片生成器',
        runwayTitle: 'Runway AI 影片生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance，将您的舞蹈创意转化为精彩视频',
        ctaButton: '在 WeryAI 上試用 Seedance',

        ctaDisclaimer: '無需信用卡',

    },
    pl: {

        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dance Video Creation',
        pageDescription: 'Experience Seedance video generator by ByteDance with dance video creation, motion generation, and diverse style features. Create professional AI dance videos for free on WeryAI platform.',
        pageKeywords: 'Seedance, AI video generator, dance video creation, motion generation, music synchronization, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'a new AI video generation model launched by ByteDance',
        generatorDescriptionText2: ', formed by the merger of Pixeldance and Seedweed development teams. Seedance 1.0 recently ',
        generatorDescriptionHighlight2: 'ranks first on the Video Arena leaderboard',
        generatorDescriptionText3: '. The tool features ',
        generatorDescriptionHighlight3: 'multi-shot capabilities, smooth and directed camera movement',
        generatorDescriptionText4: ' and more! Use ',
        generatorDescriptionHighlight4: 'Seedance on WeryAI to create AI videos',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Main Features of Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Accurate Semantic Understanding',
        accurateSemanticDescription: 'Precisely interprets complex user prompts',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamic Camera Control',
        dynamicCameraControlDescription: 'Including zoom, pan, and tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-Shot Generation with Consistency',
        multiShotGenerationDescription: 'Generates multiple shots while maintaining consistency',

        // Support for multiple styles
        multipleStylesTitle: 'Support for Multiple Styles',
        multipleStylesDescription: 'Supports various artistic styles and themes',

        // How to use section
        howToUseTitle: 'Jak używać',
        step1Title: 'Select Seedance Model',
        step1Description: 'Go to the "AI Video Generation" page, then click "Seedance" in the model dropdown menu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Input Your Dance Creative Ideas',
        step2Description: 'Describe the dance style and movements you want to generate, or upload reference images, and choose your preferred music and rhythm.',
        step3Title: 'Download Your Dance Video',
        step3Description: 'Click "Create" to download or share the generated spectacular dance video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance now and transform your dance ideas into amazing videos',
        ctaButton: 'Try Seedance on WeryAI',

        ctaDisclaimer: 'No credit card required',

    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Video Seedance 1.0 Pro - Creación de Videos de Danza con IA',
        pageDescription: 'Experimenta el generador de video Seedance de ByteDance con creación de videos de danza, generación de movimientos y características de estilos diversos. Crea videos de danza IA profesionales gratis en la plataforma WeryAI.',
        pageKeywords: 'Seedance, generador de video IA, creación de video de danza, generación de movimiento, sincronización musical, video IA gratis, WeryAI, producción de video',
    
        // Sección del generador
        generatorTitle: 'Generador de Video Seedance 1.0 Pro',
        generatorDescription: 'Seedance es ',
        generatorDescriptionHighlight1: 'un nuevo modelo de generación de video IA lanzado por ByteDance',
        generatorDescriptionText2: ', formado por la fusión de los equipos de desarrollo de Pixeldance y Seedweed. Seedance 1.0 recientemente ',
        generatorDescriptionHighlight2: 'ocupa el primer lugar en la clasificación de Video Arena',
        generatorDescriptionText3: '. ¡La herramienta cuenta con ',
        generatorDescriptionHighlight3: 'capacidades multi-toma, movimiento de cámara suave y dirigido',
        generatorDescriptionText4: ' y más! Usa ',
        generatorDescriptionHighlight4: 'Seedance en WeryAI para crear videos IA',
        generatorDescriptionEnd: '.',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
    
        // Sección de características principales
        coreFeaturesTitle: 'Funciones Principales de Seedance 1.0 Pro',
    
        // Comprensión semántica precisa
        accurateSemanticTitle: 'Comprensión Semántica Precisa',
        accurateSemanticDescription: 'Interpreta con precisión prompts complejos de usuarios',
    
        // Control dinámico de cámara
        dynamicCameraControlTitle: 'Control Dinámico de Cámara',
        dynamicCameraControlDescription: 'Incluye zoom, paneo y seguimiento',
    
        // Generación multi-toma con consistencia
        multiShotGenerationTitle: 'Generación Multi-Toma con Consistencia',
        multiShotGenerationDescription: 'Genera múltiples tomas manteniendo la consistencia',
    
        // Soporte para múltiples estilos
        multipleStylesTitle: 'Soporte para Múltiples Estilos',
        multipleStylesDescription: 'Soporta varios estilos artísticos y temas',
    
        // Sección cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Seedance',
        step1Description: 'Ve a la página "Generación de Video IA", luego haz clic en "Seedance" en el menú desplegable de modelos.',
        step1DescriptionHighlight: 'Generación de Video IA',
        step2Title: 'Introduce Tus Ideas Creativas de Danza',
        step2Description: 'Describe el estilo de danza y movimientos que deseas generar, o sube imágenes de referencia, y elige tu música y ritmo preferidos.',
        step3Title: 'Descarga Tu Video de Danza',
        step3Description: 'Haz clic en "Crear" para descargar o compartir el espectacular video de danza generado.',
    
        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo Seedance',
    
        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones Populares de X sobre el Modelo Seedance',
    
        // Sección explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        seedanceProFastTitle: 'Generador de Video IA Seedance 1.0 Pro Fast',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        runwayTitle: 'Generador de Video IA Runway',
    
        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',
    
        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta Seedance ahora y transforma tus ideas de danza en videos increíbles',
        ctaButton: 'Prueba Seedance en WeryAI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur de Vidéo Seedance 1.0 Pro - Création de Vidéos de Danse IA',
        pageDescription: 'Découvrez le générateur de vidéo Seedance de ByteDance avec création de vidéos de danse, génération de mouvements et fonctionnalités de styles divers. Créez des vidéos de danse IA professionnelles gratuitement sur la plateforme WeryAI.',
        pageKeywords: 'Seedance, générateur de vidéo IA, création de vidéo de danse, génération de mouvement, synchronisation musicale, vidéo IA gratuite, WeryAI, production vidéo',
    
        // Section du générateur
        generatorTitle: 'Générateur de Vidéo Seedance 1.0 Pro',
        generatorDescription: 'Seedance est ',
        generatorDescriptionHighlight1: 'un nouveau modèle de génération de vidéo IA lancé par ByteDance',
        generatorDescriptionText2: ', formé par la fusion des équipes de développement Pixeldance et Seedweed. Seedance 1.0 a récemment ',
        generatorDescriptionHighlight2: 'occupé la première place du classement Video Arena',
        generatorDescriptionText3: '. L\'outil dispose de ',
        generatorDescriptionHighlight3: 'capacités multi-plans, mouvements de caméra fluides et dirigés',
        generatorDescriptionText4: ' et plus encore ! Utilisez ',
        generatorDescriptionHighlight4: 'Seedance sur WeryAI pour créer des vidéos IA',
        generatorDescriptionEnd: '.',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',
    
        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Seedance 1.0 Pro',
    
        // Compréhension sémantique précise
        accurateSemanticTitle: 'Compréhension Sémantique Précise',
        accurateSemanticDescription: 'Interprète avec précision les prompts complexes des utilisateurs',
    
        // Contrôle dynamique de la caméra
        dynamicCameraControlTitle: 'Contrôle Dynamique de la Caméra',
        dynamicCameraControlDescription: 'Y compris zoom, panoramique et suivi',
    
        // Génération multi-plans avec cohérence
        multiShotGenerationTitle: 'Génération Multi-Plans avec Cohérence',
        multiShotGenerationDescription: 'Génère plusieurs plans tout en maintenant la cohérence',
    
        // Support de plusieurs styles
        multipleStylesTitle: 'Support de Plusieurs Styles',
        multipleStylesDescription: 'Prend en charge divers styles artistiques et thèmes',
    
        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Seedance',
        step1Description: 'Allez à la page "Génération Vidéo IA", puis cliquez sur "Seedance" dans le menu déroulant des modèles.',
        step1DescriptionHighlight: 'Génération Vidéo IA',
        step2Title: 'Saisissez Vos Idées Créatives de Danse',
        step2Description: 'Décrivez le style de danse et les mouvements que vous souhaitez générer, ou téléchargez des images de référence, et choisissez votre musique et rythme préférés.',
        step3Title: 'Téléchargez Votre Vidéo de Danse',
        step3Description: 'Cliquez sur "Créer" pour télécharger ou partager la vidéo de danse spectaculaire générée.',
    
        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Seedance',
    
        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Seedance',
    
        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        seedanceProFastTitle: 'Générateur de Vidéo IA Seedance 1.0 Pro Fast',
        sora2Title: 'Générateur de Vidéo IA OpenAI Sora-2',
        runwayTitle: 'Générateur de Vidéo IA Runway',
    
        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
    
        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez Seedance maintenant et transformez vos idées de danse en vidéos incroyables',
        ctaButton: 'Essayez Seedance sur WeryAI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Videogenerator - KI-Tanzvideo-Erstellung',
        pageDescription: 'Erleben Sie den Seedance Videogenerator von ByteDance mit Tanzvideo-Erstellung, Bewegungsgenerierung und vielfältigen Stilfunktionen. Erstellen Sie kostenlos professionelle KI-Tanzvideos auf der WeryAI-Plattform.',
        pageKeywords: 'Seedance, KI-Videogenerator, Tanzvideo-Erstellung, Bewegungsgenerierung, Musiksynchronisation, kostenloses KI-Video, WeryAI, Videoproduktion',
    
        // Generator-Abschnitt
        generatorTitle: 'Seedance 1.0 Pro Videogenerator',
        generatorDescription: 'Seedance ist ',
        generatorDescriptionHighlight1: 'ein neues KI-Videogenerierungsmodell, das von ByteDance eingeführt wurde',
        generatorDescriptionText2: ', gebildet durch die Fusion der Pixeldance- und Seedweed-Entwicklungsteams. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'belegt kürzlich den ersten Platz auf der Video Arena-Bestenliste',
        generatorDescriptionText3: '. Das Tool verfügt über ',
        generatorDescriptionHighlight3: 'Multi-Shot-Funktionen, flüssige und gerichtete Kamerabewegungen',
        generatorDescriptionText4: ' und mehr! Verwenden Sie ',
        generatorDescriptionHighlight4: 'Seedance auf WeryAI, um KI-Videos zu erstellen',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
    
        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Hauptfunktionen von Seedance 1.0 Pro',
    
        // Präzises semantisches Verständnis
        accurateSemanticTitle: 'Präzises Semantisches Verständnis',
        accurateSemanticDescription: 'Interpretiert präzise komplexe Benutzer-Prompts',
    
        // Dynamische Kamerasteuerung
        dynamicCameraControlTitle: 'Dynamische Kamerasteuerung',
        dynamicCameraControlDescription: 'Einschließlich Zoom, Schwenk und Verfolgung',
    
        // Multi-Shot-Generierung mit Konsistenz
        multiShotGenerationTitle: 'Multi-Shot-Generierung mit Konsistenz',
        multiShotGenerationDescription: 'Generiert mehrere Aufnahmen bei gleichzeitiger Beibehaltung der Konsistenz',
    
        // Unterstützung mehrerer Stile
        multipleStylesTitle: 'Unterstützung Mehrerer Stile',
        multipleStylesDescription: 'Unterstützt verschiedene künstlerische Stile und Themen',
    
        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        step1Title: 'Seedance Modell Auswählen',
        step1Description: 'Gehen Sie zur Seite "KI-Videogenerierung" und klicken Sie dann auf "Seedance" im Modell-Dropdown-Menü.',
        step1DescriptionHighlight: 'KI-Videogenerierung',
        step2Title: 'Geben Sie Ihre Kreativen Tanzideen Ein',
        step2Description: 'Beschreiben Sie den Tanzstil und die Bewegungen, die Sie generieren möchten, oder laden Sie Referenzbilder hoch und wählen Sie Ihre bevorzugte Musik und Ihren Rhythmus.',
        step3Title: 'Laden Sie Ihr Tanzvideo Herunter',
        step3Description: 'Klicken Sie auf "Erstellen", um das generierte spektakuläre Tanzvideo herunterzuladen oder zu teilen.',
    
        // YouTube-Videos-Abschnitt
        youtubeTitle: 'YouTube-Videos über das Seedance Modell',
    
        // X-Beiträge-Abschnitt
        xPostsTitle: 'Beliebte X-Beiträge über das Seedance Modell',
    
        // Andere Modelle erkunden-Abschnitt
        exploreModelsTitle: 'Andere Modelle Erkunden',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast KI-Videogenerator',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        runwayTitle: 'Runway KI-Videogenerator',
    
        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
    
        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Seedance jetzt und verwandeln Sie Ihre Tanzideen in erstaunliche Videos',
        ctaButton: 'Testen Sie Seedance auf WeryAI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Генератор видео Seedance 1.0 Pro - Создание танцевальных видео с ИИ',
        pageDescription: 'Испытайте генератор видео Seedance от ByteDance с созданием танцевальных видео, генерацией движений и функциями разнообразных стилей. Создавайте профессиональные танцевальные видео с ИИ бесплатно на платформе WeryAI.',
        pageKeywords: 'Seedance, генератор видео ИИ, создание танцевального видео, генерация движений, синхронизация музыки, бесплатное видео ИИ, WeryAI, производство видео',
    
        // Раздел генератора
        generatorTitle: 'Генератор видео Seedance 1.0 Pro',
        generatorDescription: 'Seedance - это ',
        generatorDescriptionHighlight1: 'новая модель генерации видео с ИИ, запущенная ByteDance',
        generatorDescriptionText2: ', сформированная слиянием команд разработки Pixeldance и Seedweed. Seedance 1.0 недавно ',
        generatorDescriptionHighlight2: 'занял первое место в рейтинге Video Arena',
        generatorDescriptionText3: '. Инструмент имеет ',
        generatorDescriptionHighlight3: 'возможности мультикадра, плавное и направленное движение камеры',
        generatorDescriptionText4: ' и многое другое! Используйте ',
        generatorDescriptionHighlight4: 'Seedance на WeryAI для создания видео с ИИ',
        generatorDescriptionEnd: '.',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',
    
        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Seedance 1.0 Pro',
    
        // Точное семантическое понимание
        accurateSemanticTitle: 'Точное семантическое понимание',
        accurateSemanticDescription: 'Точно интерпретирует сложные пользовательские промпты',
    
        // Динамическое управление камерой
        dynamicCameraControlTitle: 'Динамическое управление камерой',
        dynamicCameraControlDescription: 'Включая масштабирование, панорамирование и отслеживание',
    
        // Мультикадровая генерация с последовательностью
        multiShotGenerationTitle: 'Мультикадровая генерация с последовательностью',
        multiShotGenerationDescription: 'Генерирует несколько кадров, сохраняя последовательность',
    
        // Поддержка нескольких стилей
        multipleStylesTitle: 'Поддержка нескольких стилей',
        multipleStylesDescription: 'Поддерживает различные художественные стили и темы',
    
        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        step1Title: 'Выберите модель Seedance',
        step1Description: 'Перейдите на страницу "Генерация видео с ИИ", затем нажмите "Seedance" в выпадающем меню моделей.',
        step1DescriptionHighlight: 'Генерация видео с ИИ',
        step2Title: 'Введите ваши творческие танцевальные идеи',
        step2Description: 'Опишите стиль танца и движения, которые вы хотите сгенерировать, или загрузите референсные изображения и выберите предпочитаемую музыку и ритм.',
        step3Title: 'Скачайте ваше танцевальное видео',
        step3Description: 'Нажмите "Создать", чтобы скачать или поделиться сгенерированным зрелищным танцевальным видео.',
    
        // Раздел видео на YouTube
        youtubeTitle: 'Видео на YouTube о модели Seedance',
    
        // Раздел постов X
        xPostsTitle: 'Популярные посты X о модели Seedance',
    
        // Раздел исследования других моделей
        exploreModelsTitle: 'Исследовать другие модели',
        seedanceProFastTitle: 'Генератор видео ИИ Seedance 1.0 Pro Fast',
        sora2Title: 'Генератор видео ИИ OpenAI Sora-2',
        runwayTitle: 'Генератор видео ИИ Runway',
    
        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
    
        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Seedance сейчас и превратите ваши танцевальные идеи в потрясающие видео',
        ctaButton: 'Попробуйте Seedance на WeryAI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Vídeo Seedance 1.0 Pro - Criação de Vídeos de Dança com IA',
        pageDescription: 'Experimente o gerador de vídeo Seedance da ByteDance com criação de vídeos de dança, geração de movimentos e recursos de estilos diversos. Crie vídeos de dança IA profissionais gratuitamente na plataforma WeryAI.',
        pageKeywords: 'Seedance, gerador de vídeo IA, criação de vídeo de dança, geração de movimento, sincronização musical, vídeo IA grátis, WeryAI, produção de vídeo',
    
        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Seedance 1.0 Pro',
        generatorDescription: 'Seedance é ',
        generatorDescriptionHighlight1: 'um novo modelo de geração de vídeo IA lançado pela ByteDance',
        generatorDescriptionText2: ', formado pela fusão das equipes de desenvolvimento Pixeldance e Seedweed. Seedance 1.0 recentemente ',
        generatorDescriptionHighlight2: 'ocupa o primeiro lugar no ranking da Video Arena',
        generatorDescriptionText3: '. A ferramenta apresenta ',
        generatorDescriptionHighlight3: 'capacidades multi-shot, movimento de câmera suave e direcionado',
        generatorDescriptionText4: ' e muito mais! Use ',
        generatorDescriptionHighlight4: 'Seedance no WeryAI para criar vídeos IA',
        generatorDescriptionEnd: '.',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
    
        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Seedance 1.0 Pro',
    
        // Compreensão semântica precisa
        accurateSemanticTitle: 'Compreensão Semântica Precisa',
        accurateSemanticDescription: 'Interpreta com precisão prompts complexos de usuários',
    
        // Controle dinâmico de câmera
        dynamicCameraControlTitle: 'Controle Dinâmico de Câmera',
        dynamicCameraControlDescription: 'Incluindo zoom, pan e rastreamento',
    
        // Geração multi-shot com consistência
        multiShotGenerationTitle: 'Geração Multi-Shot com Consistência',
        multiShotGenerationDescription: 'Gera múltiplos shots mantendo a consistência',
    
        // Suporte para múltiplos estilos
        multipleStylesTitle: 'Suporte para Múltiplos Estilos',
        multipleStylesDescription: 'Suporta vários estilos artísticos e temas',
    
        // Seção como usar
        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Seedance',
        step1Description: 'Vá para a página "Geração de Vídeo IA", depois clique em "Seedance" no menu suspenso de modelos.',
        step1DescriptionHighlight: 'Geração de Vídeo IA',
        step2Title: 'Insira Suas Ideias Criativas de Dança',
        step2Description: 'Descreva o estilo de dança e movimentos que deseja gerar, ou faça upload de imagens de referência, e escolha sua música e ritmo preferidos.',
        step3Title: 'Baixe Seu Vídeo de Dança',
        step3Description: 'Clique em "Criar" para baixar ou compartilhar o vídeo de dança espetacular gerado.',
    
        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo Seedance',
    
        // Seção de publicações X
        xPostsTitle: 'Publicações Populares do X sobre o Modelo Seedance',
    
        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        seedanceProFastTitle: 'Gerador de Vídeo IA Seedance 1.0 Pro Fast',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        runwayTitle: 'Gerador de Vídeo IA Runway',
    
        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
    
        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Seedance agora e transforme suas ideias de dança em vídeos incríveis',
        ctaButton: 'Experimente o Seedance no WeryAI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Video Seedance 1.0 Pro - Creazione di Video di Danza con IA',
        pageDescription: 'Scopri il generatore di video Seedance di ByteDance con creazione di video di danza, generazione di movimenti e funzionalità di stili diversi. Crea video di danza IA professionali gratuitamente sulla piattaforma WeryAI.',
        pageKeywords: 'Seedance, generatore video IA, creazione video danza, generazione movimento, sincronizzazione musicale, video IA gratuito, WeryAI, produzione video',
    
        // Sezione generatore
        generatorTitle: 'Generatore di Video Seedance 1.0 Pro',
        generatorDescription: 'Seedance è ',
        generatorDescriptionHighlight1: 'un nuovo modello di generazione video IA lanciato da ByteDance',
        generatorDescriptionText2: ', formato dalla fusione dei team di sviluppo Pixeldance e Seedweed. Seedance 1.0 recentemente ',
        generatorDescriptionHighlight2: 'si classifica al primo posto nella classifica Video Arena',
        generatorDescriptionText3: '. Lo strumento presenta ',
        generatorDescriptionHighlight3: 'capacità multi-inquadratura, movimento della fotocamera fluido e diretto',
        generatorDescriptionText4: ' e altro ancora! Usa ',
        generatorDescriptionHighlight4: 'Seedance su WeryAI per creare video IA',
        generatorDescriptionEnd: '.',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',
    
        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Seedance 1.0 Pro',
    
        // Comprensione semantica accurata
        accurateSemanticTitle: 'Comprensione Semantica Accurata',
        accurateSemanticDescription: 'Interpreta con precisione prompt utente complessi',
    
        // Controllo dinamico della fotocamera
        dynamicCameraControlTitle: 'Controllo Dinamico della Fotocamera',
        dynamicCameraControlDescription: 'Inclusi zoom, panoramica e tracciamento',
    
        // Generazione multi-inquadratura con coerenza
        multiShotGenerationTitle: 'Generazione Multi-Inquadratura con Coerenza',
        multiShotGenerationDescription: 'Genera più inquadrature mantenendo la coerenza',
    
        // Supporto per più stili
        multipleStylesTitle: 'Supporto per Più Stili',
        multipleStylesDescription: 'Supporta vari stili artistici e temi',
    
        // Sezione come usare
        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Seedance',
        step1Description: 'Vai alla pagina "Generazione Video IA", quindi clicca su "Seedance" nel menu a discesa dei modelli.',
        step1DescriptionHighlight: 'Generazione Video IA',
        step2Title: 'Inserisci le Tue Idee Creative di Danza',
        step2Description: 'Descrivi lo stile di danza e i movimenti che vuoi generare, o carica immagini di riferimento, e scegli la tua musica e ritmo preferiti.',
        step3Title: 'Scarica il Tuo Video di Danza',
        step3Description: 'Clicca su "Crea" per scaricare o condividere il video di danza spettacolare generato.',
    
        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Seedance',
    
        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Seedance',
    
        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        seedanceProFastTitle: 'Generatore Video IA Seedance 1.0 Pro Fast',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        runwayTitle: 'Generatore Video IA Runway',
    
        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
    
        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Prova Seedance ora e trasforma le tue idee di danza in video straordinari',
        ctaButton: 'Prova Seedance su WeryAI',
        ctaDisclaimer: 'Non è richiesta la carta di credito',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد الفيديو Seedance 1.0 Pro - إنشاء فيديوهات رقص بالذكاء الاصطناعي',
        pageDescription: 'جرب مولد الفيديو Seedance من ByteDance مع إنشاء فيديوهات الرقص، وتوليد الحركة، وميزات الأنماط المتنوعة. أنشئ فيديوهات رقص احترافية بالذكاء الاصطناعي مجانًا على منصة WeryAI.',
        pageKeywords: 'Seedance, مولد فيديو ذكاء اصطناعي, إنشاء فيديو رقص, توليد حركة, مزامنة موسيقية, فيديو ذكاء اصطناعي مجاني, WeryAI, إنتاج فيديو',
    
        // قسم المولد
        generatorTitle: 'مولد الفيديو Seedance 1.0 Pro',
        generatorDescription: 'Seedance هو ',
        generatorDescriptionHighlight1: 'نموذج جديد لتوليد الفيديو بالذكاء الاصطناعي أطلقته ByteDance',
        generatorDescriptionText2: '، تشكل من دمج فرق تطوير Pixeldance و Seedweed. Seedance 1.0 مؤخرًا ',
        generatorDescriptionHighlight2: 'يحتل المرتبة الأولى في تصنيف Video Arena',
        generatorDescriptionText3: '. تتميز الأداة بـ ',
        generatorDescriptionHighlight3: 'قدرات متعددة اللقطات، حركة كاميرا سلسة وموجهة',
        generatorDescriptionText4: ' والمزيد! استخدم ',
        generatorDescriptionHighlight4: 'Seedance على WeryAI لإنشاء مقاطع فيديو بالذكاء الاصطناعي',
        generatorDescriptionEnd: '.',
        
        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
    
        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Seedance 1.0 Pro',
    
        // الفهم الدلالي الدقيق
        accurateSemanticTitle: 'فهم دلالي دقيق',
        accurateSemanticDescription: 'يفسر بدقة المطالبات المعقدة للمستخدمين',
    
        // التحكم الديناميكي في الكاميرا
        dynamicCameraControlTitle: 'تحكم ديناميكي في الكاميرا',
        dynamicCameraControlDescription: 'بما في ذلك التكبير والتحريك والتتبع',
    
        // توليد متعدد اللقطات مع الاتساق
        multiShotGenerationTitle: 'توليد متعدد اللقطات مع الاتساق',
        multiShotGenerationDescription: 'يولد عدة لقطات مع الحفاظ على الاتساق',
    
        // دعم أنماط متعددة
        multipleStylesTitle: 'دعم أنماط متعددة',
        multipleStylesDescription: 'يدعم أنماط فنية ومواضيع مختلفة',
    
        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'اختر نموذج Seedance',
        step1Description: 'انتقل إلى صفحة "توليد الفيديو بالذكاء الاصطناعي"، ثم انقر على "Seedance" في القائمة المنسدلة للنماذج.',
        step1DescriptionHighlight: 'توليد الفيديو بالذكاء الاصطناعي',
        step2Title: 'أدخل أفكارك الإبداعية للرقص',
        step2Description: 'صف أسلوب الرقص والحركات التي تريد توليدها، أو قم بتحميل صور مرجعية، واختر الموسيقى والإيقاع المفضلين لديك.',
        step3Title: 'قم بتنزيل فيديو الرقص الخاص بك',
        step3Description: 'انقر على "إنشاء" لتنزيل أو مشاركة فيديو الرقص المذهل المُنشأ.',
    
        // قسم فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج Seedance',
    
        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج Seedance',
    
        // قسم استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        seedanceProFastTitle: 'مولد الفيديو بالذكاء الاصطناعي Seedance 1.0 Pro Fast',
        sora2Title: 'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2',
        runwayTitle: 'مولد الفيديو بالذكاء الاصطناعي Runway',
    
        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
    
        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Seedance الآن وحوّل أفكارك للرقص إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Seedance على WeryAI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - การสร้างวิดีโอเต้นด้วย AI',
        pageDescription: 'สัมผัสตัวสร้างวิดีโอ Seedance จาก ByteDance ที่มีฟีเจอร์สร้างวิดีโอเต้น สร้างการเคลื่อนไหว และสไตล์หลากหลาย สร้างวิดีโอเต้น AI ระดับมืออาชีพได้ฟรีบน WeryAI.',
        pageKeywords: 'Seedance, ตัวสร้างวิดีโอ AI, การสร้างวิดีโอเต้น, การสร้างการเคลื่อนไหว, ซิงก์เพลง, วิดีโอ AI ฟรี, WeryAI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance คือ ',
        generatorDescriptionHighlight1: 'โมเดลสร้างวิดีโอ AI ใหม่ที่เปิดตัวโดย ByteDance',
        generatorDescriptionText2: ', ที่เกิดจากการรวมทีมพัฒนา Pixeldance และ Seedweed. Seedance 1.0 ล่าสุด ',
        generatorDescriptionHighlight2: 'ครองอันดับ 1 บนกระดานผู้นำ Video Arena',
        generatorDescriptionText3: '. เครื่องมือนี้มี ',
        generatorDescriptionHighlight3: 'ความสามารถหลายช็อต การเคลื่อนกล้องลื่นไหลและกำหนดทิศทางได้',
        generatorDescriptionText4: ' และอีกมากมาย! ใช้ ',
        generatorDescriptionHighlight4: 'Seedance บน WeryAI เพื่อสร้างวิดีโอ AI',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'ความเข้าใจเชิงความหมายแม่นยำ',
        accurateSemanticDescription: 'ตีความพรอมป์ต์ที่ซับซ้อนได้อย่างแม่นยำ',

        // Dynamic camera control
        dynamicCameraControlTitle: 'การควบคุมกล้องแบบไดนามิก',
        dynamicCameraControlDescription: 'รวมถึงการซูม การแพน และการติดตาม',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'สร้างหลายช็อตอย่างสอดคล้อง',
        multiShotGenerationDescription: 'สร้างหลายช็อตพร้อมรักษาความสม่ำเสมอ',

        // Support for multiple styles
        multipleStylesTitle: 'รองรับหลายสไตล์',
        multipleStylesDescription: 'รองรับสไตล์และธีมศิลป์หลากหลาย',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'เลือกโมเดล Seedance',
        step1Description: 'ไปที่หน้า "การสร้างวิดีโอด้วย AI" แล้วคลิก "Seedance" ในเมนูดรอปดาวน์โมเดล.',
        step1DescriptionHighlight: 'การสร้างวิดีโอด้วย AI',
        step2Title: 'ใส่ไอเดียการเต้นของคุณ',
        step2Description: 'อธิบายสไตล์และท่าทางการเต้นที่ต้องการ หรืออัปโหลดภาพอ้างอิง แล้วเลือกเพลงและจังหวะที่ชอบ.',
        step3Title: 'ดาวน์โหลดวิดีโอเต้นของคุณ',
        step3Description: 'คลิก "Create" เพื่อดาวน์โหลดหรือแชร์วิดีโอเต้นที่สร้างขึ้น.',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Seedance',

        // X Posts section
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับโมเดล Seedance',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast ตัวสร้างวิดีโอ AI',
        sora2Title: 'OpenAI Sora-2 ตัวสร้างวิดีโอ AI',
        runwayTitle: 'Runway ตัวสร้างวิดีโอ AI',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription: 'ลองใช้ Seedance ตอนนี้และเปลี่ยนไอเดียการเต้นของคุณเป็นวิดีโอสุดพิเศษ',
        ctaButton: 'ลอง Seedance บน WeryAI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansevideoproduktion',
        pageDescription: 'Oplev Seedance-videogeneratoren fra ByteDance med dansevideo-produktion, bevægelsesgenerering og mange stilarter. Skab professionelle AI-dansevideoer gratis på WeryAI.',
        pageKeywords: 'Seedance, AI videogenerator, dansevideo, bevægelsesgenerering, musik-synkronisering, gratis AI video, WeryAI, videoproduktion',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance er ',
        generatorDescriptionHighlight1: 'en ny AI-videogenereringsmodel lanceret af ByteDance',
        generatorDescriptionText2: ', skabt ved fusionen af udviklingsteamsene Pixeldance og Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'ligger for nylig nr. 1 på Video Arena-leaderboardet',
        generatorDescriptionText3: '. Værktøjet har ',
        generatorDescriptionHighlight3: 'multi-shot-funktioner, glidende og styret kamerabevægelse',
        generatorDescriptionText4: ' og mere! Brug ',
        generatorDescriptionHighlight4: 'Seedance på WeryAI til at skabe AI-videoer',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunktioner i Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Præcis semantisk forståelse',
        accurateSemanticDescription: 'Fortolker komplekse brugerprompter præcist',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamisk kamerastyring',
        dynamicCameraControlDescription: 'Inklusive zoom, pan og tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generering med konsistens',
        multiShotGenerationDescription: 'Genererer flere shots og bevarer konsistens',

        // Support for multiple styles
        multipleStylesTitle: 'Understøtter flere stilarter',
        multipleStylesDescription: 'Understøtter forskellige kunstneriske stilarter og temaer',

        // How to use section
        howToUseTitle: 'Sådan bruges',
        step1Title: 'Vælg Seedance-model',
        step1Description: 'Gå til siden "AI Video Generation" og klik derefter på "Seedance" i model-dropdownen.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Indtast dine kreative danseidéer',
        step2Description: 'Beskriv den dansestil og de bevægelser, du vil generere, eller upload referencebilleder, og vælg din foretrukne musik og rytme.',
        step3Title: 'Download din dansevideo',
        step3Description: 'Klik på "Create" for at downloade eller dele den genererede dansevideo.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Seedance-modellen',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',

        // CTA section
        ctaTitle: 'Klar til at skabe?',
        ctaDescription: 'Oplev Seedance nu og forvandl dine danseidéer til fantastiske videoer',
        ctaButton: 'Prøv Seedance på WeryAI',
        ctaDisclaimer: 'Intet kreditkort kræves',
        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansevideoproduksjon',
        pageDescription: 'Opplev Seedance-videogeneratoren fra ByteDance med dansevideo-produksjon, bevegelsesgenerering og mange stiler. Lag profesjonelle AI-dansevideoer gratis på WeryAI.',
        pageKeywords: 'Seedance, AI videogenerator, dansevideo, bevegelsesgenerering, musikksynkronisering, gratis AI video, WeryAI, videoproduksjon',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance er ',
        generatorDescriptionHighlight1: 'en ny AI-videogenereringsmodell lansert av ByteDance',
        generatorDescriptionText2: ', dannet av sammenslåingen av utviklingsteamene Pixeldance og Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'ligger nylig som nr. 1 på Video Arena-leaderboardet',
        generatorDescriptionText3: '. Verktøyet har ',
        generatorDescriptionHighlight3: 'multi-shot-funksjoner, jevn og styrt kamerabevegelse',
        generatorDescriptionText4: ' og mer! Bruk ',
        generatorDescriptionHighlight4: 'Seedance på WeryAI for å lage AI-videoer',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Hovedfunksjoner i Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Presis semantisk forståelse',
        accurateSemanticDescription: 'Tolker komplekse brukerprompter presist',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamisk kamerakontroll',
        dynamicCameraControlDescription: 'Inkluderer zoom, pan og tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generering med konsistens',
        multiShotGenerationDescription: 'Genererer flere shots og opprettholder konsistens',

        // Support for multiple styles
        multipleStylesTitle: 'Støtte for flere stiler',
        multipleStylesDescription: 'Støtter ulike kunstneriske stiler og temaer',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Velg Seedance-modell',
        step1Description: 'Gå til siden "AI Video Generation", og klikk deretter "Seedance" i modellnedtrekket.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Legg inn dine kreative danseideer',
        step2Description: 'Beskriv dansestilen og bevegelsene du vil generere, eller last opp referansebilder, og velg ønsket musikk og rytme.',
        step3Title: 'Last ned dansevideoen',
        step3Description: 'Klikk "Create" for å laste ned eller dele den genererte dansevideoen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Seedance-modellen',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaDescription: 'Prøv Seedance nå og gjør danseideene dine om til fantastiske videoer',
        ctaButton: 'Prøv Seedance på WeryAI',
        ctaDisclaimer: 'Ingen kredittkort kreves',
        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro videogenerator - AI-dansvideoproductie',
        pageDescription: 'Ervaar de Seedance-videogenerator van ByteDance met dansvideoproductie, bewegingsgeneratie en diverse stijlen. Maak gratis professionele AI-dansvideo\'s op WeryAI.',
        pageKeywords: 'Seedance, AI videogenerator, dansvideoproductie, bewegingsgeneratie, muzieksynchronisatie, gratis AI video, WeryAI, videoproductie',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro videogenerator',
        generatorDescription: 'Seedance is ',
        generatorDescriptionHighlight1: 'een nieuw AI-videogeneratiemodel gelanceerd door ByteDance',
        generatorDescriptionText2: ', gevormd door de fusie van de ontwikkelteams Pixeldance en Seedweed. Seedance 1.0 ',
        generatorDescriptionHighlight2: 'staat onlangs op nummer 1 in de Video Arena-ranglijst',
        generatorDescriptionText3: '. De tool biedt ',
        generatorDescriptionHighlight3: 'multi-shot-mogelijkheden, vloeiende en gerichte camerabewegingen',
        generatorDescriptionText4: ' en meer! Gebruik ',
        generatorDescriptionHighlight4: 'Seedance op WeryAI om AI-video\'s te maken',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Belangrijkste functies van Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Nauwkeurige semantische begrip',
        accurateSemanticDescription: 'Interpreteert complexe prompts precies',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dynamische camerabesturing',
        dynamicCameraControlDescription: 'Inclusief zoom, pan en tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Multi-shot-generatie met consistentie',
        multiShotGenerationDescription: 'Genereert meerdere shots met behoud van consistentie',

        // Support for multiple styles
        multipleStylesTitle: 'Ondersteuning voor meerdere stijlen',
        multipleStylesDescription: 'Ondersteunt verschillende artistieke stijlen en thema\'s',

        // How to use section
        howToUseTitle: 'Hoe te gebruiken',
        step1Title: 'Selecteer het Seedance-model',
        step1Description: 'Ga naar de pagina "AI Video Generation" en klik vervolgens op "Seedance" in het modeldropdownmenu.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Voer je creatieve dansideeën in',
        step2Description: 'Beschrijf de dansstijl en bewegingen die je wilt genereren, of upload referentiebeelden, en kies je favoriete muziek en ritme.',
        step3Title: 'Download je dansvideo',
        step3Description: 'Klik op "Create" om de gegenereerde dansvideo te downloaden of te delen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Seedance-model',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over het Seedance-model',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        runwayTitle: 'Runway AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',

        // CTA section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaDescription: 'Ervaar Seedance nu en transformeer je dansideeën in geweldige video\'s',
        ctaButton: 'Probeer Seedance op WeryAI',
        ctaDisclaimer: 'Geen creditcard nodig',
        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - Pembuatan Video Tari AI',
        pageDescription: 'Rasakan generator video Seedance dari ByteDance dengan pembuatan video tari, generasi gerak, dan fitur gaya beragam. Buat video tari AI profesional gratis di WeryAI.',
        pageKeywords: 'Seedance, generator video AI, pembuatan video tari, generasi gerak, sinkronisasi musik, video AI gratis, WeryAI, produksi video',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance adalah ',
        generatorDescriptionHighlight1: 'model generasi video AI baru yang diluncurkan oleh ByteDance',
        generatorDescriptionText2: ', hasil penggabungan tim pengembangan Pixeldance dan Seedweed. Seedance 1.0 baru-baru ini ',
        generatorDescriptionHighlight2: 'menempati peringkat pertama di leaderboard Video Arena',
        generatorDescriptionText3: '. Alat ini memiliki ',
        generatorDescriptionHighlight3: 'kemampuan multi-shot, pergerakan kamera halus dan terarah',
        generatorDescriptionText4: ' dan lainnya! Gunakan ',
        generatorDescriptionHighlight4: 'Seedance di WeryAI untuk membuat video AI',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Seedance 1.0 Pro',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Pemahaman Semantik yang Akurat',
        accurateSemanticDescription: 'Menafsirkan prompt pengguna yang kompleks dengan presisi',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Kontrol Kamera Dinamis',
        dynamicCameraControlDescription: 'Termasuk zoom, pan, dan tracking',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Generasi Multi-Shot yang Konsisten',
        multiShotGenerationDescription: 'Menghasilkan beberapa shot sambil menjaga konsistensi',

        // Support for multiple styles
        multipleStylesTitle: 'Mendukung Banyak Gaya',
        multipleStylesDescription: 'Mendukung berbagai gaya dan tema artistik',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        step1Title: 'Pilih Model Seedance',
        step1Description: 'Buka halaman "AI Video Generation", lalu klik "Seedance" pada menu dropdown model.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Masukkan Ide Kreatif Tarian Anda',
        step2Description: 'Jelaskan gaya tari dan gerakan yang ingin dibuat, atau unggah gambar referensi, lalu pilih musik dan ritme favorit.',
        step3Title: 'Unduh Video Tarian Anda',
        step3Description: 'Klik "Create" untuk mengunduh atau membagikan video tarian spektakuler yang dihasilkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Seedance',

        // X Posts section
        xPostsTitle: 'Posting X Populer tentang Model Seedance',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Lain',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',

        // CTA section
        ctaTitle: 'Siap Mulai Berkarya?',
        ctaDescription: 'Coba Seedance sekarang dan ubah ide tarian Anda menjadi video yang menakjubkan',
        ctaButton: 'Coba Seedance di WeryAI',
        ctaDisclaimer: 'Tanpa kartu kredit',
        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Seedance 1.0 Pro Video Generator - AI Dans Videosu Üretimi',
        pageDescription: 'ByteDance’in Seedance video üreticisiyle dans videosu oluşturma, hareket üretimi ve çeşitli stil özelliklerini deneyimleyin. WeryAI’de ücretsiz profesyonel AI dans videoları üretin.',
        pageKeywords: 'Seedance, AI video üretici, dans videosu oluşturma, hareket üretimi, müzik senkronizasyonu, ücretsiz AI video, WeryAI, video prodüksiyonu',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Video Generator',
        generatorDescription: 'Seedance, ',
        generatorDescriptionHighlight1: 'ByteDance tarafından piyasaya sürülen yeni bir AI video üretim modeli',
        generatorDescriptionText2: ' olup Pixeldance ve Seedweed ekiplerinin birleşmesiyle oluşturuldu. Seedance 1.0 yakın zamanda ',
        generatorDescriptionHighlight2: 'Video Arena sıralamasında birinci sırada yer aldı',
        generatorDescriptionText3: '. Araç ',
        generatorDescriptionHighlight3: 'çoklu sahne, akıcı ve yönlendirilmiş kamera hareketi',
        generatorDescriptionText4: ' gibi özellikler sunar! ',
        generatorDescriptionHighlight4: 'WeryAI’de Seedance ile AI videolar oluşturun',
        generatorDescriptionEnd: '.',
        
        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro’nun Temel Özellikleri',

        // Accurate semantic understanding
        accurateSemanticTitle: 'Doğru Anlamsal Anlama',
        accurateSemanticDescription: 'Karmaşık kullanıcı istemlerini hassas şekilde yorumlar',

        // Dynamic camera control
        dynamicCameraControlTitle: 'Dinamik Kamera Kontrolü',
        dynamicCameraControlDescription: 'Zoom, pan ve takip dahil',

        // Multi-shot generation with consistency
        multiShotGenerationTitle: 'Tutarlılıkla Çoklu Sahne Üretimi',
        multiShotGenerationDescription: 'Tutarlılığı koruyarak birden fazla sahne üretir',

        // Support for multiple styles
        multipleStylesTitle: 'Birden Fazla Stil Desteği',
        multipleStylesDescription: 'Çeşitli sanatsal stilleri ve temaları destekler',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        step1Title: 'Seedance Modelini Seçin',
        step1Description: '"AI Video Generation" sayfasına gidin ve model açılır menüsünden "Seedance"ı seçin.',
        step1DescriptionHighlight: 'AI Video Generation',
        step2Title: 'Yaratıcı Dans Fikirlerinizi Girin',
        step2Description: 'Üretmek istediğiniz dans stilini ve hareketleri açıklayın veya referans görseller yükleyin, ardından müzik ve ritminizi seçin.',
        step3Title: 'Dans Videonuzu İndirin',
        step3Description: 'Oluşturulan muhteşem dans videosunu indirmek veya paylaşmak için "Create"e tıklayın.',

        // YouTube videos section
        youtubeTitle: 'Seedance Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Seedance Modeli Hakkında Popüler X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        seedanceProFastTitle: 'Seedance 1.0 Pro Fast AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        runwayTitle: 'Runway AI Video Generator',

        // FAQ section
        faqTitle: 'Sık Sorulan Sorular',

        // CTA section
        ctaTitle: 'Oluşturmaya Hazır mısınız?',
        ctaDescription: 'Seedance’i şimdi deneyin ve dans fikirlerinizi harika videolara dönüştürün',
        ctaButton: 'WeryAI’de Seedance’i Deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
    },
}
